
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HpoPatientObjectType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hpo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"ticPrefix"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tic"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"treatmentPriority"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isChild"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryUnknown"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthDay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthYear"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"birthNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nonStandardBirthNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"insurance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"policeVerification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diagnose"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ventilated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitTypeSpec"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"callSign"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transportPriority"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hospitalType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transportStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hospital"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"transportMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transportDestinationRequestStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rejectionReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"temporaryIdentifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"admittedToHospitalTimestamp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"destinationWard"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timestampLastUpdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"timestamp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageHeight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thumbnailWidth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thumbnailHeight"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":957}};
    doc.loc.source = {"body":"fragment PatientListFragment on HpoPatientObjectType{\n    id,\n    hpo{\n        id\n    }\n    ticPrefix\n    ticNumber\n    tic\n    treatmentPriority\n    gender\n    isChild\n    status\n    country\n    countryUnknown\n    firstName\n    lastName\n    birthDay\n    birthMonth\n    birthYear\n    birthDate\n    birthNumber\n    nonStandardBirthNumber\n    insurance\n    phoneNumber\n    address\n    city\n    note\n    policeVerification\n    diagnose\n    ventilated\n    unitType\n    unitTypeSpec\n    callSign\n    transportPriority\n    hospitalType\n    transportStatus\n    hospital {\n        id\n        name\n    }\n    transportMinutes\n    eta\n    transportDestinationRequestStatus\n    rejectionReason\n    temporaryIdentifier\n    admittedToHospitalTimestamp\n    destinationWard\n    timestampLastUpdate\n\n    images {\n        id\n        timestamp\n        imageUrl\n        imageWidth\n        imageHeight\n        thumbnailUrl\n        thumbnailWidth\n        thumbnailHeight\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PatientListFragment"] = oneQuery(doc, "PatientListFragment");
        
